import { call, put } from 'redux-saga/effects';
import {
  generateReportFailed,
  generateReportSuccess,
  getAllReportsFailed,
  getAllReportsSuccess,
} from '../../actions/reports';
import { GENERATE_REPORT, GET_ALL_REPORTS } from '../../constants/urls';
import zfetch, {
  METHOD_GET,
  METHOD_POST,
} from '../../pages/common/utils/zfetch';
import { openErrorToast } from '../../reducers/uiLogic';
import { genericErrorMsg } from '../../constants';

const getAllReports = ({ workspaceId }) => {
  const options = {
    method: METHOD_GET,
    params: { workspace_id: workspaceId },
  };
  return zfetch(GET_ALL_REPORTS, options);
};

export function* getAllReportsSaga(action) {
  let reportsData = {};
  try {
    const response = yield getAllReports(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    reportsData = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getAllReportsFailed(err));
    return;
  }
  yield put(getAllReportsSuccess(reportsData));
}

const generateReport = ({ reportBody = {} }) => {
  const options = {
    body: JSON.stringify(reportBody),
    method: METHOD_POST,
  };
  return zfetch(GENERATE_REPORT, options);
};

const getGenerateReport = report => {
  return generateReport(report).then(res => res.json());
};

export function* generateReportSaga(action) {
  let generateReportDetails = {};
  try {
    generateReportDetails = yield call(() => {
      return getGenerateReport(action.payload);
    });
  } catch (err) {
    yield put(openErrorToast(genericErrorMsg));
    yield put(generateReportFailed(err));
    return;
  }
  const { status = false, message = {} } = generateReportDetails;
  if (!status) {
    yield put(openErrorToast(message?.title ?? genericErrorMsg));
    yield put(generateReportFailed());
  } else {
    yield put(generateReportSuccess(generateReportDetails));
  }
}
